import React from "react";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import * as echarts from "echarts";
import _ from 'lodash';


export const ChartAffective = (props) => {
    const { jsonData, chartName, chartHeight } = props;
    const { t } = useTranslation();
    const chartRef = React.useRef(null);
    const myChart = React.useRef(null);

    const getFontsize = () => {
        if (window.innerWidth < 600) {
            return 12;
        } else if (window.innerWidth < 900) {
            return 20;
        } else if (window.innerWidth < 1200) {
            return 30;
        }
    }


    React.useEffect(() => {
        if (!myChart.current && chartRef.current) {
            myChart.current = echarts.init(chartRef.current);
        }

        const affectiveData = jsonData?.map((item, index) => ({
            idx: index + 1,
            id: item.name.toLowerCase().trim(),
            name: t(`assessment.${item.name.toLowerCase().trim().replace(/\s+/g, '')}`),
            value: item.value,
            color: item.itemStyle.color,
            itemStyle: { color: item.itemStyle.color, }
        })) || [];

        const option = {
            legend: {
                top: 'bottom'
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c}'
            },
            toolbox: {
                show: false,
                feature: {
                    mark: { show: true },
                    dataView: { show: true, readOnly: true },
                    restore: { show: true },
                    saveAsImage: { show: true }
                }
            },
            // color: affectiveData.sort(item => item.idx).map(item => item.color),
            series: [{
                name: chartName || '',
                type: 'treemap',
                width: '100%',
                height: '100%',
                drillDownIcon: false,
                roam: false,
                nodeClick: false,
                breadcrumb: {
                    show: false,
                },
                itemStyle: {
                    borderWidth: (1),
                    borderRadius: (10),
                    borderColor: 'rgba(47, 45, 44, 1)',
                },
                label: {
                    fontStyle: 'oblique',
                    fontSize: getFontsize() || Math.round(myChart.current._dom.offsetWidth / 32),
                    fontWeight: 'bold',
                    formatter: (param) => {
                        return (`${param.name}`) + `${'\n'}${param.value}`;
                    },
                    rotate: 20,
                },
                data: affectiveData.sort(item => item.idx),
            }]
        };

        if (myChart.current) {
            myChart.current.showLoading();
            myChart.current.setOption(option);
            myChart.current.hideLoading();
        }
        
        
        // 창크기 변경할때 카트를 갱신한다.
        const handleResize = _.debounce(() => {
            if (myChart.current) {
                myChart.current.showLoading();
                myChart.current.setOption(option);
                myChart.current?.resize();
                myChart.current.hideLoading();
            }
        }, 50); // Debounce for 50ms

        window.addEventListener('resize', handleResize);

        return () => {
            try {
                window.removeEventListener('resize', handleResize);
            
                myChart.current && myChart.current.dispose();
                myChart.current && myChart.current.dispose();
                myChart.current = null;
            }
            catch (err) {
                console.log("Unload", new Date().toISOString(), JSON.stringify(err), err);
            }
        };
    }, [jsonData, chartName, chartHeight]);


    return <div ref={chartRef} style={{ width: "100%", height: chartHeight || "600px" }} />;
};

ChartAffective.propTypes = {
    jsonData: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.func,
        PropTypes.object,
    ]).isRequired,
    chartName: PropTypes.string,
    chartHeight: PropTypes.string,
};
